module.exports = __webpack_public_path__ + "static/img/blo5.45bb6863.png";